import * as React from "react";
import PlacedGCPIcon from "../../../react/icons/map/PlacedGCPIcon";
import { Black, White } from "@traceair/tds";
import GcpIcon from "../../../react/icons/map/GcpIcon";
import { getCorruptedIconColors } from "./flightMarkerIcon";
import { IMarkerIconParams } from "./GcpMapIcon";
import { ExistingControlMarkerIcon } from "./ExistingControlMarkerIcon";

// in updated design, icons in the sidebar and on the map are a little different
// (map icons have outline)
export const GcpSidebarIcon = (params: IMarkerIconParams) => {
  switch (params.type) {
    case "gcp": {
      if (params.corruptionType != null) {
        const iconColors = getCorruptedIconColors(params.corruptionType);
        // on a white background white outline is not visible, it is
        // to avoid an extra icon component without outline
        return <GcpIcon color={iconColors.color} outlineColor={White} />;
      }
      return <PlacedGCPIcon color={Black} />;
    }
    case "existing":
      return (
        <ExistingControlMarkerIcon
          isExistingHighPrio={params.isExistingHighPrio}
          isSelected={params.isSelected}
        />
      );
  }
};
